import Component from "../qlib/Component";
import SimpleComponentRegistery from "../qlib/SimpleComponentRegistery";
import "jquery-form";

export default class FormComponent extends Component
{
    constructor(element)
    {
        super(element);

        let originalHeight = $(element).height();

        let errorMessage = 'Sorry er is een technische fout ontstaan. Neem telefonisch contact met ons op.';
        let successMessage = 'Succesvol verzonden.';

        // Custom message by html
        let successMessageSelector = this.element.getAttribute("data-successmessage-selector");
        if (successMessageSelector) {
            let successMessageTemplate = document.querySelector(successMessageSelector);
            if (successMessageTemplate) {
                successMessage = $(successMessageTemplate).html();
            }
        }

        function alertMessage(type, message) {
            // Try to find existing alert html (but not alert-info)
            let alertHtml = element.querySelector('.alert:not(.alert-info)');

            if (!alertHtml) {
                element.innerHTML += `<div class="alert collapse mt-2 mb-0"></div>`;
                alertHtml = element.querySelector('.alert');
            }

            if (type === 'success') {
                alertHtml.classList.remove('alert-danger');
                // alertHtml.classList.remove('alert-info');
                alertHtml.classList.add('alert-success');
                element.reset();
            } else if (type === 'error') {
                alertHtml.classList.remove('alert-success');
                // alertHtml.classList.remove('alert-info');
                alertHtml.classList.add('alert-danger');
            }

            alertHtml.classList.add('show');
            if(alertHtml.hasAttribute('data-alert-remove')) {
                setTimeout(function() {
                    alertHtml.classList.remove('show');
                }, 5000);
            }

            alertHtml.innerHTML = message;

            // Replace entire form is default behavior
            if (type === 'success' && !alertHtml.hasAttribute('data-alert-no-replace-form') && !element.hasAttribute('data-alert-no-replace-form')) {
                // Old if part: || (alertHtml.hasAttribute('data-alert-replace-form') || element.hasAttribute('data-alert-replace-form'))

                // Remove any margin classes
                for (let step = 1; step <= 10; step++) {
                    alertHtml.classList.remove('mt-'+step);
                }

                // Position succes message at the bottom
                $(element).css('display', 'flex');
                $(element).css('padding-bottom', '10px');
                $(element).css('min-height', `${originalHeight}px`);

                $(alertHtml).css('margin-top', 'auto');
                $(alertHtml).css('flex', '1 0 100%');

                // Replace entire form html
                element.innerHTML = alertHtml.outerHTML;
            }
        }

        function removeErrorStyle() {
            let fields = element.querySelectorAll('.is-invalid');

            for (let i = 0; i < fields.length; i++) {
                fields[i].classList.remove('is-invalid');
            }
        }

        $(element).ajaxForm({
            dataType: 'json',
            success: function(response){
                if (response.success || (response.responseJSON && response.responseJSON.success)) {
                    switch (element.dataset.formType) {
                        case 'ebook':
                            alertMessage('success', 'Het document bevindt zich nu in uw downloads. Mocht dit niet zo zijn, hebben we het document ook per mail verstuurd.');
                            removeErrorStyle();
                        break;

                        default:
                            if (response.message) {
                                successMessage = response.message;
                            }

                            alertMessage('success', successMessage);
                            removeErrorStyle();
                        break;
                    }
                } else {
                    if (response.responseJSON && response.responseJSON.X_QBALL_ERROR_MESSAGE) {
                        errorMessage = response.responseJSON.X_QBALL_ERROR_MESSAGE;
                    }
                    alertMessage('error', errorMessage);
                }

                $(element).css('min-height', `${originalHeight}px`);

                if (response.downloadUrl !== undefined) {
                    window.location.href = response.downloadUrl;
                }
            },
            error: function(response){

                if (response.responseJSON && response.responseJSON.X_QBALL_ERROR_MESSAGE) {
                    alertMessage('error', response.responseJSON.X_QBALL_ERROR_MESSAGE);
                }

                // if (response.)
                if (response.status === 500) {
                    $(element).css('min-height', `${originalHeight}px`);
                    alertMessage('error', errorMessage);
                    return;
                }

                let data = response.responseJSON.X_QBALL_ERROR_FIELDS;
                for (var k in data) {
                    if (data.hasOwnProperty(k)) {
                       let input = element.querySelector('input[name="'+k+'"], textarea[name="'+k+'"]');
                       if (!input) continue;

                       if (data[k]) {
                         input.classList.add('is-invalid');
                       } else {
                         input.classList.remove('is-invalid');
                       }

                    }
                }

            }
        });

    }

    onMessage(type, data)
    {

    }
}

SimpleComponentRegistery.register("form", FormComponent);
